/**
 * Created by Samyan Wahla on 9/3/2015.
 */
(function () {
    'use strict';

    var app = angular.module('tmx-app');
    app.controller('registerCtrl', ['$scope','$http', 'RegistrationUserDataService','ENV','$location','$mdToast',
        '$auth','$translate', 'userInputRestrictions','ServerExceptionService','ToastService','imageService','APP_CONSTANTS',
        function RegisterCtrl ($scope,$http, RegistrationUserDataService,ENV,$location,$mdToast,$auth,$translate,userInputRestrictions,
            ServerExceptionService,ToastService,imageService,APP_CONSTANTS) {


            this.restrict = userInputRestrictions; // set controller object equal to controller property to be
                // accessed from html page

            var vm = this;
            vm.Upload = '';
            vm.Photo = '';
            vm.FirstName = 'FirstName';
            vm.LastName = 'LastName';
            vm.CompanyName = 'CompanyName';
            vm.Email = 'Email';
            vm.Register = 'Register';
            vm.AlreadyAccount = 'AlreadyAccount';
            vm.SignIn = 'SignIn';

            $scope.changeCulture = function(culture) {
                localStorage.setItem('culture', culture);
                $translate.use(culture);
            }

            vm.date = new Date();
             //   $scope.register = register;
            $scope.user = RegistrationUserDataService.user; //sets the empty user object created by factory to
            $scope.user.Tenant= {};

            $scope.user.Tenant.TenantName= "Kashf Foundation Bank";


                //A check to see if image already loaded by user
            if($scope.user.ImageUrl != null) {
                $('#ProfilePic').src = $scope.user.ImageUrl;
                $('#StudentImgHidden').src = $scope.user.ImageUrl;
            }
            if($scope.user != null){
                $scope.user.Admin={};
                $scope.user.Admin.FirstName = $scope.user.FirstName;
                $scope.user.Admin.LastName = $scope.user.LastName;
                $scope.user.Admin.EmailAddress = $scope.user.EmailAddress;
            }
            RegistrationUserDataService.user ={};


////////////  WATCHING FOR CHANGES IN THE ERROR in HTTP RESPONSE IN REGISTER/////////////////////////////////////
            $scope.$watch(function () { return ServerExceptionService.Displaymsg}, function (newVal, oldVal) {
                if($scope.watch_count > 1) {
                    return;
                }

                if (typeof newVal !== 'undefined' && $scope.watch_count == 1) {
                    $scope.error = ServerExceptionService.Displaymsg;
                    $scope.dataLoading = false; // remove the loading imaging when error is displayed
                    $scope.watch_count = $scope.watch_count+1;
                    ServerExceptionService.Displaymsg = oldVal;//to differentiate old value from new value when user signs
                         // in multiple time using incorrect username and password and the server returns the same error
                    $scope.$on("$destroy", function(){
                        ServerExceptionService.Displaymsg = "";
                    });
                }
            });
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            $scope.register = function () {
                $scope.dataLoading = true;
                $scope.watch_count = 1;
                    // OAuth.isAuthenticated();
                $scope.error="";
                var imgEle = document.getElementById("StudentImgHidden");
                $scope.getBase64Image(imgEle).then(handleResizedImg, rejectResizedImg);
                $scope.oldImage = imgEle;
                $scope.dataLoading = true;
                if ($scope.user.Admin.socialData == null) {
                    $scope.user.Admin.socialData = {};
                }


            };
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                 /////////////////////////////////////////////RESIZE HIDDEN IMAGE//////////////////////////////////////////////////////
                 /////SUCCESS FUNCTION///
            function handleResizedImg(resizedImage){

                     // do something with resized image
                     // imgElem must be on the same server otherwise a cross-origin error will be thrown "SECURITY_ERR: DOM Exception 18"
                var canvas = document.createElement("canvas");//document.getElementById('myCanvas');//
                     //canvas.width = resizedImage.width;
                     //canvas.height = resizedImage.height;
                var ctx = canvas.getContext("2d");
                     //ctx.drawImage(resizedImage, 0, 0);


                var imageObj = new Image();


                     //cropping white space
                imageObj.onload = function() {
                         // draw cropped image
                    var sourceX = 0;
                    var sourceY = 0;
                    var sourceWidth;
                    var sourceHeight;
                    if($scope.oldImage.width < resizedImage.width && $scope.oldImage.height < resizedImage.height){
                        sourceWidth = resizedImage.width;
                        sourceHeight = resizedImage.height;
                    }
                    else {
                        sourceWidth = 600;
                        sourceHeight = 450;
                    }

                    var destWidth = sourceWidth;
                    var destHeight = sourceHeight;

                    var destX = 0;//canvasN.width / 2 - destWidth / 2;
                    var destY = 0;//canvasN.height / 2 - destHeight / 2;
                    canvas.width = destWidth;
                    canvas.height = destHeight;
                    ctx.drawImage(imageObj, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight);
                    $scope.dataURL = canvas.toDataURL("image/png");
                         // var dataURL = $('#StudentImgHidden').attr('src');
                    $scope.dataURL = $scope.dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
                    $scope.user.Admin.ImageData = $scope.dataURL;
                    $scope.user.clientId=APP_CONSTANTS.cliendId;

                         // TODO: this condition should either go in an array or be inverted
                    if(ENV.backend.indexOf("azurewebsites") != -1 //== 'http://tmxprovisioningapi.azurewebsites.net/api'
                             //|| ENV.backend ==  'http://tmxmfapi.azurewebsites.net/api/v1/'
                             //|| ENV.backend ==  'http://tmxmfapitest.azurewebsites.net/api/v1/'
                    ){
                        $http.post(ENV.backend + '/tenant/register' + ENV.login_redirectURI_Azure, $scope.user).then(handleSuccess);
                    }
                    else {
                        $http.post(ENV.backend + '/tenant/register' + ENV.login_redirectURI_KHI, $scope.user).then(handleSuccess);
                    }


                };
                imageObj.src = resizedImage.src;

            }

                 /////ERROR FUNCION/////
            function rejectResizedImg(){
                ServerExceptionService.Displaymsg = "Error Resizing the Picture!";
            }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            function handleSuccess(data) {
                $scope.dataLoading = false;
                $scope.form.$setPristine();
                $scope.form.$setUntouched();
                $("#fileError").html("");//setting image error to empty string

                if (data.data.access_token == null) {

                    $location.path('/login'); //redirection to login page


                    ToastService.showCustomToast("success","Your Account has been registered successfully. Please check your mail.");


                }
                else {

                    $auth.setToken(data.data.access_token);
                    var currentURL = $location.absUrl().replace('index.html#', 'Index.html#');
                    window.location.assign( currentURL.replace('Index.html#'+$location.url(),'private.html'));
                            //window.location.assign($location.absUrl().replace('index.html#' + $location.url(), 'private.html'));
                    $mdToast.show(
                        $mdToast.simple()
                            .content('Your account has been successfully registered. Welcome to TmX!')
                            .position('top right')
                            .hideDelay(6000)
                    );
                }


            }


            $scope.imageChoose=function() {
                document.getElementById('imgFile').click();
            };


////////////////////////////////GETTING BASE ^$ IMAGE AND RESIZING IT BEFORE SENDING TO SERVER/////////////////////
            $scope.getBase64Image=function(imgElem) {

                     //if( $scope.Imgsize != undefined &&  $scope.Imgsize != null &&  $scope.Imgsize > 1000000) {
                         // resize the picture by lanczos-sinc filter
                return(imageService.resize(imgElem, 600, 600));
                     //}

            };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            $scope.showImage = function(fileInput) {
                var files = fileInput.files;
                for (let i = 0; i < files.length; i++) {
                    let file = files[i];
                    let imageType = /image.*/;
                    if (!file.type.match(imageType)) {
                        $("#fileError").html("Upload an Image File!");
                        $("#imgFile").val("");
                        continue;
                    }
                    if (file.size > 1000000) {
                        $scope.Imgsize = file.size;
                            //$("#fileError").html("WARNING: Your file size is > 1 MB!");
                            //$("#imgFile").val("");
                            //return;
                    }
                    else {
                        $("#fileError").html("");
                    }

                    let img = document.getElementById("ProfilePic");
                    img.file = file;
                    $scope.user.ImageUrl=file.name;
                    let reader = new FileReader();
                    reader.onload = (function (aImg) {
                        return function (e) {
                            aImg.src = e.target.result;
                        };
                    })(img);
                    reader.readAsDataURL(file);
                }


                files = fileInput.files;
                for (let i = 0; i < files.length; i++) {
                    let file = files[i];
                    let imageType = /image.*/;
                    if (!file.type.match(imageType)) {
                        {

                            continue;
                        }
                    }
                    let img = document.getElementById("StudentImgHidden");
                    img.file = file;
                    $scope.user.ImageUrl= file.name;
                    let reader = new FileReader();
                    reader.onload = (function (aImg) {
                        return function (e) {
                            aImg.src = e.target.result;
                        };
                    })(img);
                    reader.readAsDataURL(file);
                }

                $("#uploadData").html("Update<br/>Photo");
            };

            $scope.fadeError = function() {
                $("#fileError").html("");
                     //    $('#fileError').fadeOut('fast');
            };
                 //}, 5000); // <-- time in milliseconds
                 //


        }]);
})(); //end of file